<template>
  <div>
    <div
      class="modal fade"
      id="modal-vehiculo-patente"
      tabindex="-1"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-sm">
          <div class="modal-header bg-geogo border-0">
            <h5 class="modal-title d-flex align-items-center text-white">
              Asignación de Patentes - {{ placa_vehiculo }}
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Cerrar"
              ref="closeModal"
              @click="limpiarModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="small text-uppercase text-muted font-weight-bold">
                <i class="fas fa-tint mr-1"></i>
                Cisterna
              </label>
              <v-select
                v-model="cisterna"
                :options="listas.cisternas"
                placeholder="Buscar cisterna por placa..."
                label="placa"
                class="form-control form-control-sm p-0"
                @search="buscarCisternas"
                @input="getSelectCisterna()"
                :class="[
                  $v.form.cisterna_id.$invalid ? 'is-invalid' : 'is-valid',
                  $store.getters.getDarkMode ? 'dark-vselect' : '',
                ]"
                :disabled="bloquear"
              ></v-select>
            </div>
            <div class="form-group">
              <label class="small text-uppercase text-muted font-weight-bold">
                <i class="fas fa-building mr-1"></i>
                Cliente
              </label>
              <v-select
                v-model="cliente"
                :options="listas.clientes"
                placeholder="Buscar cliente..."
                label="razon_social"
                class="form-control form-control-sm p-0"
                @search="buscarClientes"
                @input="getSelectCliente()"
                :class="[
                  $v.form.cliente_id.$invalid ? 'is-invalid' : 'is-valid',
                  $store.getters.getDarkMode ? 'dark-vselect' : '',
                ]"
                :disabled="bloquear"
              ></v-select>
            </div>
            <div class="form-group mb-0">
              <label class="small text-uppercase text-muted font-weight-bold">
                <i class="fas fa-truck mr-1"></i>
                Transportadora
              </label>
              <v-select
                v-model="transportadora"
                :options="listas.transportadoras"
                placeholder="Seleccione transportadora..."
                label="razon_social"
                class="form-control form-control-sm p-0"
                @search="getTransportadoras"
                @input="getSelectTransportadora()"
                :class="[
                  $v.form.empresa_id.$invalid ? 'is-invalid' : 'is-valid',
                  $store.getters.getDarkMode ? 'dark-vselect' : '',
                ]"
                :disabled="bloquear"
              ></v-select>
            </div>
            <div
              class="form-group mt-3"
              v-if="patentes_cliente && patentes_cliente.length > 0"
            >
              <table class="table table-sm table-bordered text-center">
                <thead class="table-dark">
                  <tr>
                    <th>Cisterna</th>
                    <th>Empresa</th>
                    <th>Cisterna</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="patente in patentes_cliente" :key="patente.id">
                    <td>{{ patente.pivot.cisterna.placa }}</td>
                    <td>{{ patente.pivot.empresa.razon_social }}</td>
                    <td>{{ patente.razon_social }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="eliminarPatente(patente)"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer border border-gray rounded-bottom bg-light">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              ref="closeModal"
              @click="limpiarModal()"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              v-if="!$v.form.$invalid"
            >
              <i class="fas fa-save mr-1"></i>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "VehiculoPatente",
  components: {
    vSelect,
  },
  data() {
    return {
      form: {
        cisterna_id: null,
        cliente_id: null,
        empresa_id: null,
      },
      bloquear: false,
      patentes_cliente: [],
      cisterna: null,
      cliente: null,
      transportadora: null,
      listas: {
        cisternas: [],
        clientes: [],
        transportadoras: [],
      },
      vehiculo_id: null,
      placa_vehiculo: null,
    };
  },

  validations: {
    form: {
      cisterna_id: {
        required,
      },
      cliente_id: {
        required,
      },
      empresa_id: {
        required,
      },
    },
  },

  methods: {
    buscarCisternas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        // OBLIGATORIO: Buscar solo cisternas con pais_id = 3
        var url = "/api/argentina/trailers/lista?placa=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.listas.cisternas = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarClientes(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        // OBLIGATORIO: Buscar solo empresas con pais_id = 3
        var url =
          "/api/argentina/clientes/lista?razon_social=" + search + "&pais_id=3";
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.listas.clientes = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getTransportadoras(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        // OBLIGATORIO: Buscar solo empresas con pais_id = 3
        var url =
          "/api/argentina/empresas/lista?razon_social=" + search + "&pais_id=3";
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.listas.transportadoras = respuesta;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getSelectCisterna() {
      this.form.cisterna_id = null;
      if (this.cisterna) {
        this.form.cisterna_id = this.cisterna.id;
      }
    },

    getSelectCliente() {
      this.form.cliente_id = null;
      if (this.cliente) {
        this.form.cliente_id = this.cliente.id;
      }
    },

    getSelectTransportadora() {
      this.form.empresa_id = null;
      if (this.transportadora) {
        this.form.empresa_id = this.transportadora.id;
      }
    },

    save() {
      this.$parent.cargando = true;
      axios({
        method: "PUT",
        url: "/api/argentina/camiones/savePatente",
        data: this.form,
      })
        .then((response) => {
          this.limpiarModal();
          this.$swal({
            icon: "success",
            title: "La patente se asignó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error, vuelva a intentarlo..." + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },

    eliminarPatente(patente) {
      this.$swal({
        title: "Esta seguro de eliminar este Item?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios({
            method: "PUT",
            url: "/api/argentina/camiones/savePatente",
            data: {
              cisterna_id: patente.pivot.cisterna_id,
              cliente_id: patente.pivot.cliente_id,
              empresa_id: patente.pivot.empresa_id,
              vehiculo_id: this.form.vehiculo_id,
              deleted: true,
            },
          })
            .then((response) => {
              this.limpiarModal();
              this.$parent.getIndex();
              this.$swal({
                icon: "success",
                title: "La patente se eliminó exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.$parent.cargando = false;
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Ocurrio un error, vuelva a intentarlo..." + error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.$parent.cargando = false;
            });
        }
      });
    },

    limpiarModal() {
      this.$refs.closeModal.click();
      this.form.cisterna_id = null;
      this.form.cliente_id = null;
      this.form.empresa_id = null;
      this.form.vehiculo_id = null;
      this.cisterna = {};
      this.cliente = {};
      this.transportadora = {};
      this.placa_vehiculo = null;
    },

    abrir(patentes_cliente, vehiculoId, vehiculoPlaca) {
      this.limpiarModal();
      this.form.vehiculo_id = vehiculoId;
      this.placa_vehiculo = vehiculoPlaca;
      this.patentes_cliente = patentes_cliente;
      this.bloquear = patentes_cliente.length > 0 ? true : false;
    },
  },
  mounted() {},
};
</script>
